import _ from 'lodash';
import { AddressRequest, AddressResponse } from './Dto/Address';
import Moment from 'moment';
import { OccupationalLevel } from './Enum/OccupationalLevel';
import { EmployeeType } from './Enum/EmployeeType';
import { IDropDownOptions } from '../Common/Components/FormValidationInputs/AppSelectList';
import { BarrierCategoryTypes } from './Enum/BarrierCategoryType';
import { toast } from 'react-toastify';
import { UserType } from './Enum/BEE123Enums';

const monthMap = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

export const defaultObject: any = {};

export const DateHelper = (date: Date) => {
    if (date) {
        const dateObj = new Date(date);
        return Intl.DateTimeFormat('en-ZA', {
            year: 'numeric',
            month: 'long',
            day: '2-digit'
        }).format(dateObj);
    }
}

export const verifyLength = (value: any, length: number) => {
    if (value.length >= length) {
        return true;
    }
    return false;
};

export const isNullOrEmpty = (value: any) => {
    if (value === null || value === undefined || value === '') {
        return true;
    }
    return false;
};

export const TableDateTimeHelper = (date: string) => {
    if (date === '0001-01-01T00:00:00') return "";
    if (date) {
        const dateObj = new Date(date);
        return Intl.DateTimeFormat('en-ZA', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        }).format(dateObj);
    }
    else {
        return "Unspecified";
    }
}

export const TableDateHelper = (date: string, includeTime: boolean = false) => {
    if (date === '0001-01-01T00:00:00') return "";
    if (date) {
        const dateObj = new Date(date);
        if(includeTime){
            return Intl.DateTimeFormat('en-ZA', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
            }).format(dateObj);
        }
        return Intl.DateTimeFormat('en-ZA', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).format(dateObj);
    }
    else {
        return "Unspecified";
    }
}

export const LongTableDateHelper = (date: string) => {
    if (date) {
        const dateObj = new Date(date);
        return Intl.DateTimeFormat('en-ZA', {
            year: 'numeric',
            month: 'long',
            day: '2-digit'
        }).format(dateObj);
    }
}

export const TableTimeHelper = (date: string) => {
    if (date) {
        const dateObj = new Date(date);
        return Intl.DateTimeFormat('en-ZA', {
            hour: '2-digit',
            minute: '2-digit'
        }).format(dateObj);
    }
}

export const DateFormatter = (date: string | null | undefined, DateFormat?: string, isUtc: boolean = false) => {
    if (date == null) {
        return "Unspecified";
    }
    if (!Moment(date).isValid()) return 'Unspecified';

    let dte = Moment(date);
    if (isUtc)
        dte = dte.utc(true).local();

    return dte.format(DateFormat ?? 'YYYY/MM/DD');
}

export const StringDateTimeHelper = (date: string, isUtc: boolean = false) => {
    if (date) {
        
        let dateObj = new Date(date);

        if (isUtc){
            let dte = Moment(date);
            dte = dte.utc(true).local();
            dateObj = dte.toDate();
        }

        return Intl.DateTimeFormat('en-ZA', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        }).format(dateObj);
    }
    return "";
}

export const DateTimeHelper = (date: Date) => {
    if (date) {
        return Intl.DateTimeFormat('en-ZA', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
    }
}

export const DataTableHtmlFormatter = (input: string, delimiter: string) => {
    if (isNullOrEmpty(input)) {
        return '';
    }
    const doc = new DOMParser().parseFromString(input, 'text/html');
    const texts = Array.from(doc.body.childNodes).map(node => node.textContent);
    return texts.join(delimiter);
}

export function MapAddressDtoOutToIn(data: AddressResponse): AddressRequest | null {
    const addressIn: AddressRequest = {};
    addressIn.AddressLine1 = data.AddressLine1;
    addressIn.AddressLine2 = data.AddressLine2;
    addressIn.CityId = data.City ? data.City.Id : null;
    addressIn.SuburbId = data.Suburb ? data.Suburb.Id : null;
    addressIn.ProvinceId = data.Province ? data.Province.Id as string : null;
    addressIn.Code = data.Code;
    return addressIn;
}

export const occupationLevelFormatter = (occupationalLevelId: number): string => {
    if (OccupationalLevel[occupationalLevelId]) {
        return OccupationalLevel[occupationalLevelId];
    }
    return '';
}

export const employeeTypeFormatter = (employeeTypeId: number): string => {
    if (EmployeeType[employeeTypeId]) {
        return EmployeeType[employeeTypeId];
    }
    return 'Invalid Employee Type';
}

export const barrierCategoryFormatter = (barrierCategoryId: number): string => {
    if (BarrierCategoryTypes[barrierCategoryId]) {
        return BarrierCategoryTypes[barrierCategoryId];
    }
    return '';
}

export const EnumToList = (enumType: any): IDropDownOptions[] => {
    // converts the enum to a list of IDropDownOptions
    const enumList: IDropDownOptions[] = [];
    for (const key in enumType) {
        if (enumType.hasOwnProperty(key)) {
            enumList.push({
                value: enumType[key],
                id: key
            });
        }
    }
    return enumList;
}

export const YesNoValue = (value: boolean): string => {
    return value ? 'Yes' : 'No';
}

export const removeWhiteSpaceChars = (input: string) => {
    return input.replace(/[\r\n\s]/g, "");
}

export const removeWhiteSpaceAndHyphenChars = (input: string) => {
    return input.replace(/[\r\n\s-']/g, "");
}

export const removeHtml = (input: string) => {

    input = (input !== null) ? input.replace(/<[^>]*>?/gm, '') : '';
    return input;
}

export const dataTableHtmlFormatter = (selector: string, trim?: number) => (row: any) => {
    let value = row[selector];
    if (value == null) return '';
    if (trim && value.length > trim) {
        value = value.substring(0, trim) + '...';
    }
    return removeHtml(value);
}

export const removeHtmlAndTrim = (input: string, trim: number) => {

    input = (input !== null) ? input.replace(/<[^>]*>?/gm, ' ') : '';
    if (input.length > trim) {
        input = input.substring(0, trim) + '...';
    }
    return input;
}

export const removeHtmlformat = (input: string) => {
    if (input === undefined) return 'N/A';
    input = (input !== null) ? input.replace(/<[^>]*>?/gm, ' ') : '';
    return input;
}

export const DateToString = (date: Date): string => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = date.toLocaleString('en-us', { month: 'long' }); //January is 0!
    const yyyy = date.getFullYear();
    return `${dd} ${mm} ${yyyy}`;

}

export const urltoFile = async (url: string, filename: string, mimeType: string) => {
    return (fetch(url)
        .then(function (res) { return res.arrayBuffer(); })
        .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
    );
}

export const getDateString = (date: Date) => {
    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
}

export const offsetTimezone = (date: Date) => {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
}

export const generateNumberedDropdownList = (x: number) => {
    const numberedList: IDropDownOptions[] = [];
    for (let i = 1; i <= x; i++) {
        numberedList.push({ id: i, value: i.toString() });
    }
    return numberedList;
}

export const onFileUpload = (event: any, uploadFileFunction: (document: any) => void) => {
    if (event.target) {
        const document = event.target.files[0];
        const fileSizeInKB = Math.ceil(document.size / 1024);
        const maxFileSizeInKB = 1024 * 20;
        let fileExt = document.name.split('.').pop();
        const allowedFileTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'doc', 'docx', 'xls', 'xlsx', 'pdf', 'zip', 'rar']
        if (allowedFileTypes.includes(fileExt.toLowerCase())) {
            if (fileSizeInKB > maxFileSizeInKB) {
                toast.error("File is bigger than 20MB");
                return;
            }
            else {
                uploadFileFunction(document);
                return;
            }
        }
        else {
            toast.error("Unsupported file type. Permitted file types are: .jpeg, .jpg, .png, .gif, .bmp, .tiff, .doc, .docx, .xls, .xlsx, .pdf, .zip, .rar");
            return;
        }
    }
}

export function getUserTypeDescription(userType: number): string {
    switch (userType) {
        case UserType.User:
            return 'User';
        case UserType.SubAdmin:
            return 'Sub-Admin';
        default:
            return 'Unknown';
    }
}

export function SimpleFullNameFormatter(firstName: string, lastName?: string) {
    return lastName ? firstName + ' ' + lastName : firstName;
}

export function ValidateEmailAddress(email: string): boolean {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
}

export function formatNumber(input: number | string): number {
    if (typeof input === 'string') {
        const formattedString = input.toString().replace(/\s/g, '');
        const value = parseInt(formattedString);
        if (isNaN(value)) {
            return 0;
        }
        return value;
    }
    return input;
}

export function formatFileSize(bytes: number) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + '' + sizes[i];
}

export const parseMonthYear = (label: string): Date | null => {
    if (!label) return null;

    const [monthStr, yearStr] = label.split("-");
    if (!monthStr || !yearStr) return null;

    const monthIndex = monthMap.indexOf(monthStr);
    if (monthIndex === -1) return null;

    const year = 2000 + parseInt(yearStr, 10);

    return new Date(year, monthIndex, 1);
};

